var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgReportProblemTriangle = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 16.806a.5.5 0 1 1-1 0V9.153a.5.5 0 1 1 1 0v7.653Z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 2.618 1.309 23h20.382L11.5 2.618ZM22.5 24H.5a.5.5 0 0 1-.447-.724l11-22a.5.5 0 0 1 .894 0l11 22A.5.5 0 0 1 22.5 24Z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.375 20a.875.875 0 1 1-1.75 0 .875.875 0 0 1 1.75 0Z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgReportProblemTriangle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/report-problem-triangle.71204114a7d3a5f27dd1bc729273bce5.svg";